import { IV2AggregateResult, v2StatsGet, IEquipmentTypeOrAll } from '@ifit/gateway-wolf-dashboard-service';
import { useQuery, UseQueryResult } from 'react-query';
import { FIFTEEN_SECONDS, ONE_DAY } from '../../util/durations';
import { useLanguage } from '../selectors/use-language';
import { useToken } from '../selectors/use-token';
import { useUserId } from '../selectors/use-user-id';

export function useUserStats(
  before: string,
  after: string,
  equipmentType: IEquipmentTypeOrAll
): UseQueryResult<IV2AggregateResult, Error> {
  const token = useToken();
  const userId = useUserId();
  const language = useLanguage();

  return useQuery<IV2AggregateResult, Error>(
    ['user-stats-v2', { userId, equipmentType, before, after, language }],
    () =>
      v2StatsGet({
        before,
        after,
        equipmentType,
        headers: { language },
      }),
    { staleTime: FIFTEEN_SECONDS, cacheTime: ONE_DAY, enabled: Boolean(token) }
  );
}
